$(function () {
  $(document).tooltip({ selector: '[data-toggle="tooltip"]' });
});

$(function () {
  $(document).popover({ selector: '[data-toggle="popover"]' });
  $("body").on("click", function (e) {
    //did not click a popover toggle or popover
    if (
      $(e.target).data("toggle") !== "popover" &&
      $(e.target).parents(".popover.in").length === 0
    ) {
      $('[data-toggle="popover"]').popover("hide");
    }
  });
  $(document).on("show.bs.popover", function () {
    $(".popover").not(this).popover("hide");
  });
});

jQuery(document).ready(function () {
  jQuery(".scrollbar-inner").scrollbar();
});

$(document).on("click", ".sidenav-toggler", function (e) {
  $toggle = $(".sidenav-toggler");

  if ($("body").hasClass("nav_open")) {
    $("body").removeClass("nav_open");
    $toggle.removeClass("toggled");
  } else {
    $("body").toggleClass("nav_open");
    $toggle.addClass("toggled");
  }
});

$(document).on("click", ".topbar-toggler", function (e) {
  $(".main-nav").remove();
  $(".mobile-nav").remove();
  $(".mobile-nav-toggle").remove();
  $(".mobile-nav-overly").remove();

  $topbar = $(".topbar-toggler");

  if ($("body").hasClass("topbar_open")) {
    $("body").removeClass("topbar_open");
    $topbar.removeClass("toggled");
  } else {
    $("body").addClass("topbar_open");
    $topbar.addClass("toggled");
  }
});

$(document).on("click", ".mobile-menu-sidebar", function (e) {
  $toggle = $(".sidenav-toggler");
  $("body").removeClass("nav_open");
  $toggle.removeClass("toggled");
});

$(document).on("click", ".no-menu-sidebar", function (e) {
  $toggle = $(".sidenav-toggler");
  $("body").removeClass("nav_open");
  $toggle.remove();
});

$(document).on("click", ".hide-topbar-open", function (e) {
  $topbar = $(".topbar-toggler");
  $("body").removeClass("topbar_open");
  $topbar.removeClass("toggled");
});

$(document).on("click", ".hide-sidebar-topbar-open", function (e) {
  $topbar = $(".topbar-toggler");
  $("body").removeClass("topbar_open");
  $topbar.removeClass("toggled");
  $(".sidenav-toggler").remove();
});

$(document).on("click", ".product-home a", function (e) {
  $(".sidenav-toggler").remove();
});

$(document).ready(function () {
  // var toggle_sidebar = false,
  // toggle_topbar = false,
  // nav_open = 0,
  // topbar_open = 0;

  // if(!toggle_sidebar) {
  // 	$toggle = $('.sidenav-toggler');

  // 	$toggle.click(function() {
  // 		if (nav_open == 1){
  // 			$('html').removeClass('nav_open');
  // 			$toggle.removeClass('toggled');
  // 			nav_open = 0;
  // 		}  else {
  // 			$('html').addClass('nav_open');
  // 			$toggle.addClass('toggled');
  // 			nav_open = 1;
  // 		}
  // 	});
  // 	toggle_sidebar = true;
  // }

  // if(!toggle_topbar) {
  // 	$topbar = $('.topbar-toggler');

  // 	$topbar.click(function(){
  // 		if (topbar_open == 1) {
  // 			$('html').removeClass('topbar_open');
  // 			$topbar.removeClass('toggled');
  // 			topbar_open = 0;
  // 		} else {
  // 			$('html').addClass('topbar_open');
  // 			$topbar.addClass('toggled');
  // 			topbar_open = 1;
  // 		}
  // 	});
  // 	toggle_topbar = true;
  // }

  //select all
  $('[data-select="checkbox"]').change(function () {
    $target = $(this).attr("data-target");
    $($target).prop("checked", $(this).prop("checked"));
  });
});

// count

$(document).ready(function () {
  $("#qty_input").prop("enabled", true);
  $("#plus-btn").click(function () {
    $("#qty_input").val(parseInt($("#qty_input").val()) + 1);
  });
  $("#minus-btn").click(function () {
    $("#qty_input").val(parseInt($("#qty_input").val()) - 1);
    if ($("#qty_input").val() == 0) {
      $("#qty_input").val(1);
    }
  });
});

function show_form() {
  document.getElementById("isi-alamat").style.display = "block";
  document.getElementById("alamat-filled").style.display = "none";
}
function hide_form() {
  document.getElementById("isi-alamat").style.display = "none";
  document.getElementById("alamat-filled").style.display = "block";
}
$("#startDate").datepicker({
  uiLibrary: "bootstrap4",
});

$("#startDate").datepicker({
  uiLibrary: "bootstrap4",
});
$("#endDate").datepicker({
  uiLibrary: "bootstrap4",
});

$(document).ready(function () {
  $("ul.tabs li").click(function () {
    var tab_id = $(this).attr("data-tab");

    $("ul.tabs li").removeClass("current");
    $(".tab-content").removeClass("current");

    $(this).addClass("current");
    $("#" + tab_id).addClass("current");
  });
});
$("#pilih-semua").click(function () {
  $(".checkbox-cart").prop("checked", $(this).prop("checked"));
});
function openCity(evt, cityName) {
  var i, tabcontent, tablinks;
  tabcontent = document.getElementsByClassName("tabcontent");
  for (i = 0; i < tabcontent.length; i++) {
    tabcontent[i].style.display = "none";
  }
  tablinks = document.getElementsByClassName("tablinks");
  for (i = 0; i < tablinks.length; i++) {
    tablinks[i].className = tablinks[i].className.replace(" active", "");
  }
  document.getElementById(cityName).style.display = "block";
  evt.currentTarget.className += " active";
}

// Get the element with id="defaultOpen" and click on it
// document.getElementById("defaultOpen").click(); appear error and idk what purpose of this ?
